
const baseURL = (typeof(window) !== 'undefined' ? window.location.origin : null) ;
const Ajax = require('./ajax');

exports.addCardsToDeck = function(insertArray){
   return Ajax.post(baseURL + "/deck/addCard", {insertArray});
};

exports.addCardToUserFavorites = function(idCard, cardType){
   return Ajax.post(baseURL + "/deck/addFavorite", {idCard, cardType});
};

exports.removeCardsFromDeck = function(deleteArray){
   return Ajax.post(baseURL + "/deck/removeCard", {deleteArray});
};

exports.getDecks = function(){
   return Ajax.get(baseURL + "/deck/get");
};

exports.getLoggedInUsers = function(){
   return Ajax.get(baseURL + "/users/getLoggedInUsers");
};

/**
 * Creates a new reasoning card
 * @param{Object} cardData - synopsis, idEvidenceCard1, idEvidenceCard2, isPrivate,
 */
exports.createReasoningCard = function(cardData){
   return Ajax.post(baseURL + "/reasoning/create", {data: JSON.stringify(cardData)});
};

exports.createStimulusCard = function(cardData){
   return Ajax.post(baseURL + "/stimulus/create", {data: JSON.stringify(cardData)});
};

exports.getEvidenceCardByID = function(id){
   return Ajax.get(baseURL + "/evidence/getByID?id=" + id);
};


/**
 * Gets most useful evidence cards
 * @param {number} start - number value representing the start day (Ex: 0 is 0 days)
 * @param {number} end - number value representing the end day (30 is 30 days ago)
*/
exports.getMostUsefulEvidence = function(limit, offset, start, end){
   return Ajax.get(baseURL + `/evidence/getMostUseful?limit=${limit}&offset=${offset}&start=${start}&end=${end}`);
};

exports.getMostComplimentedEvidence = function(limit, offset, start, end){
   return Ajax.get(baseURL + `/evidence/getMostComplimented?limit=${limit}&offset=${offset}&start=${start}&end=${end}`);
};

exports.getMostComplimentedConjecture = function(limit, offset, start, end){
   return Ajax.get(baseURL + `/conjecture/mostComplimented?limit=${limit}&offset=${offset}&start=${start}&end=${end}`);
};


exports.getGreySpaceCardByID = function(id){
   return Ajax.get(baseURL + "/reasoning/getByID?id=" + id);
};

exports.getStimulusCardByID = function(id){
   return Ajax.get(baseURL + "/stimulus/getByID?id=" + id);
};

exports.deleteStimulusCard = function(idCard){
   return Ajax.post(baseURL + "/stimulus/delete", {data: idCard});
};

exports.createStimulusCardLink = function(idStimulusCard, idEvidenceCard){
   let createModel = { idStimulusCard, idEvidenceCard };
   return Ajax.post(baseURL + "/stimulus/createLink", {data: JSON.stringify(createModel)});
};

exports.castCardVote = function(cardType, idCard, voteType){
   let data = {cardType, idCard, voteType};
   return Ajax.post(baseURL + "/votes/createCardVote", {data: JSON.stringify(data)});
};

exports.getProfileData = (idUser) =>{
   return Ajax.get(baseURL + '/users/getProfileData', {idUser});
};

exports.followUser = function(idUser){
   return Ajax.post(baseURL + "/users/followUser", {data: idUser});
};

exports.notifyCommenters = function(idPortfolio, idThread, idComment, usersToNotify) {
   let data = {
      idPortfolio,
      idThread,
      idComment,
      usersToNotify
   };
   return Ajax.post(baseURL + '/portfolio/notifyCommenters', { data });
};

exports.createCardComment = function(cardType, idCard, idParentComment, text, idPortfolio){
   let data = {
      cardType,
      idCard,
      idParentComment,
      text,
      idPortfolio,
   };
   return Ajax.post(baseURL + "/card/createComment", {data});
};

exports.createIncubatorThread = function(idIncubator, title, text) {
   let data = {
      idIncubator,
      title,
      text
   }
   return Ajax.post(baseURL + '/incubator/createThread', { ...data });
}

exports.createPortfolioComment = function(idPortfolio, idThread, idParentComment, title = '', text){
   let data = {
      idParentComment,
      idPortfolio,
      idThread,
      text,
      title,
   };
   return Ajax.post(baseURL + "/portfolio/createComment", {data});
};

exports.editPortfolioComment = function(idCardComment, idPortfolio, idThread, text) {
   return Ajax.post(baseURL + '/portfolio/editComment', {idCardComment, idPortfolio, text, idThread});
}

exports.deletePortfolioComment = function(idCardComment, idPortfolio, idThread, childCommentLength){
   return Ajax.post(baseURL + "/portfolio/deleteComment", {idCardComment, idPortfolio, idThread, childCommentLength});
};

exports.likePortfolioComment = function(idCardComment, idPortfolio, idThread){
   return Ajax.post(baseURL + "/portfolio/likeComment", {idCardComment, idPortfolio, idThread});
};

exports.pinPortfolioComment = function(idCardComment, idPortfolio, idThread, isPinned){
   return Ajax.post(baseURL + "/portfolio/pinComment", {idCardComment, idPortfolio, idThread, isPinned});
};

exports.disablePortfolioComment = function(idCardComment, idPortfolio, idThread, isDisabled){
   return Ajax.post(baseURL + "/portfolio/disableComment", {idCardComment, idPortfolio, idThread, isDisabled});
};

exports.updatePortfolioSponsorTyping = function(isTyping, idPortfolio, comment){
   return Ajax.post(baseURL + "/portfolio/updateSponsorTyping", {isTyping, idPortfolio, comment});
}

exports.deleteCardComment = function(idCardComment){
   return Ajax.post(baseURL + "/card/deleteComment", {idCardComment});
};

exports.reportCardComment = function(message, url){
   return Ajax.post(baseURL + "/card/reportComment", {message, url});
};

exports.sendSuggestion = function(message){
   return Ajax.post(baseURL + "/sendSuggestion", {message});
};

exports.getFilteredCardData = (filterData) => {
   return Ajax.post(baseURL + "/allCards/getAllFiltered", {data: filterData});
};

exports.getRandomEvidenceCardsWithList = (filterObject, numChosen, listSize) => {
   return Ajax.post(baseURL + "/evidence/getRandom", {data: JSON.stringify({filterObject, numChosen, listSize} )});
};

exports.getCurrentUserData = function(){
   return Ajax.get(baseURL + '/users/getCurrentUserData');
};

exports.completeEvidenceTutorial = function(){
   return Ajax.post(baseURL + '/achievements/completeEvidenceTutorial', {});
};

exports.completeIntroTutorial = function(){
   return Ajax.post(baseURL + '/achievements/completeIntroTutorial', {});
};

exports.createEvidenceCard = function(cardToSave){
   return Ajax.post(baseURL + '/evidence/createEvidenceCard', {data: JSON.stringify(cardToSave)});
};

exports.reviseEvidenceCard = function(cardObject){
   return Ajax.post(baseURL + '/evidence/reviseEvidence', {cardObject});
};

exports.createCardApproval = function(approvalData){
   return Ajax.post(baseURL + '/votes/createCardApproval', {data: JSON.stringify(approvalData)});
};

exports.createEvidenceApproval = function(idCard, idReviewQuestionTemplate, text){
   return Ajax.post(baseURL + '/votes/createEvidenceApproval', {idCard, idReviewQuestionTemplate, text});
};

exports.deleteEvidenceCard = function(idCard){
   return Ajax.post(baseURL + '/evidence/delete', {data: idCard});
};

exports.getNextEvidenceCardToReview = function(){
   return Ajax.get(baseURL + '/evidence/getNextCardToReview');
};

exports.getNextConjectureCardToReview = function(){
   return Ajax.get(baseURL + '/reasoning/getNextCardToReview')
};

exports.getUnapprovedCards = function(){
   return Ajax.get(baseURL + '/cards/getUnapproved');
};

exports.getEvidenceCount = function(){
   return Ajax.get(baseURL + '/evidence/getCount');
};

exports.getPrivateMessages = function(idCorrespondent){
   return Ajax.get(baseURL + "/users/getPrivateMessages?idCorrespondent=" + idCorrespondent );
};

exports.getPrivateMessageOverview = function(){
   return Ajax.get(baseURL + "/users/getPrivateMessageOverview");
};

exports.setPrivateMessagesAsRead = function(){
   return Ajax.post(baseURL + '/users/setPrivateMessagesAsRead', {});
};

exports.checkDoesUsernameExist = function(username){
   return Ajax.post(baseURL + '/users/checkDoesUsernameExist', {username});
};

exports.checkDoesUserReceiveEmails = function(){
   return Ajax.get(baseURL + '/users/checkDoesUserReceiveEmails');
};

exports.deleteConjecture = function(idCard){
   return Ajax.post(baseURL + "/reasoning/delete", {idCard});
};

exports.addWorkspaceTags = function(tagArray, idCard, cardType){
   return Ajax.post(baseURL + "/card/addWorkspaceTags", {tagArray, idCard, cardType});
};

exports.getUserPortfolios = function(){
   return Ajax.get('/portfolio/getUserPortfolios');
};

exports.getPortfolioById = function(id){
   return Ajax.get(baseURL + "/portfolio/getById?id=" + id);
};

exports.getUserTopicCount = function(id){
   return Ajax.get(baseURL + "/users/getUserTopicCount?id="+id);
};

exports.getUserPointAwardGroupCount = function(id){
   return Ajax.get(baseURL + "/users/getUserPointAwardGroupCount?id="+id);
};

exports.getIncubatorById = function(id){
   return Ajax.get(baseURL + "/incubator/getByID?id=" + id);
};

exports.getIncubatorMicroPubs = function(id) {
   return Ajax.get(baseURL + `/incubator/microPubs?id=${id}`);
};

exports.getIncubatorGraphData = function(id) {
   return Ajax.get(baseURL + `/incubator/graphData?id=${id}`);
};

exports.getIncubatorCommentsById = function(id){
   return Ajax.get(baseURL + "/incubator/getCommentsByID?id=" + id);
};

exports.getIncubatorOwnerIds = function(id) {
   return Ajax.get(`${baseURL}/incubator/ownerIds?id=${id}`);
};

exports.getIncubatorThreads = function(idIncubator) {
   return Ajax.get(`${baseURL}/incubator/getThreads?id=${idIncubator}`);
};

exports.getIncubatorThread = function(idThread, idIncubator) {
   return Ajax.get(`${baseURL}/incubator/getThread?idThread=${idThread}&idIncubator=${idIncubator}`);
};

exports.getInvitedIncubatorUsers = function(id){
   return Ajax.get(baseURL + "/incubator/getInvitedUsers?id=" + id);
};

exports.getAMAIncubator = function() {
   return Ajax.get(baseURL + '/incubator/askMeAnything');
};

exports.createOrUpdateIncubatorView = function(id){
   return Ajax.get(baseURL + "/incubator/createOrUpdateIncubatorView?id=" + id);
};

exports.getIncubatorViewsByIdForUser = function(id){
   return Ajax.get(baseURL + "/incubator/getIncubatorViewsByIdForUser?id=" + id);
};

exports.createPortfolio = function(name){
   return Ajax.post(baseURL + "/portfolio/create", {name});
};

exports.deletePortfolio = function(idPortfolio){
   return Ajax.post(baseURL + "/portfolio/delete", {idPortfolio});
};

/**
 * @param {object} portfolioData - should have the form {idCard, cardType, idPortfolio, index}
 * @returns {Promise<object>}
 */
exports.addCardsToPortfolio = function(portfolioData){
   return Ajax.post(baseURL + "/portfolio/addCard", {portfolioData});
};

exports.moveIndexInPortfolio = function(idPortfolio, oldIndex, newIndex){
   return Ajax.post(baseURL + "/portfolio/moveIndex", {idPortfolio, oldIndex, newIndex});
};

exports.removeCardFromPortfolio = function(idPortfolio, idCard, cardType, index = null){
   return Ajax.post(baseURL + "/portfolio/removeCard", {idPortfolio, idCard, cardType, index});
};

exports.createNoteCard = function(title, idPortfolio){
   return Ajax.post(baseURL + "/noteCard/create", {title, idPortfolio});
};
exports.createQuestionCard = function(title, idPortfolio){
   return Ajax.post(baseURL + "/questionCard/create", {title, idPortfolio});
};

exports.createSynthesis = function(idTemplate, idPortfolio){
   return Ajax.post(baseURL + "/portfolio/createSynthesisInstance", {idTemplate, idPortfolio});
};

exports.uploadAvatar = function(imageFile){
   return Ajax.upload('/users/uploadAvatar', imageFile);
};

exports.setUserProfile = function(userData){
   return Ajax.post(baseURL + "/users/setUserProfile", {userData});
};

exports.setUserInterests = function(idTopicArray){
   return Ajax.post(baseURL + "/users/setInterests", {idTopicArray});
};

exports.setUserExpertise = function(idTopicArray){
   return Ajax.post(baseURL + "/users/setExpertise", {idTopicArray});
};

exports.searchUsers = function(searchString){
   return Ajax.post(baseURL + "/users/search", {searchString});
};

exports.addPortfolioUser = function(idPortfolio, idUser){
   return Ajax.post(baseURL + "/portfolio/inviteUser", {idPortfolio, idUser});
};

exports.addMultiplePortfolioUsersByEmail = function(idPortfolio, userEmails){
   return Ajax.post(baseURL + "/portfolio/inviteMultipleUsersByEmail", {idPortfolio, userEmails});
};

exports.removePortfolioUser = function(idPortfolio, idUser){
   return Ajax.post(baseURL + "/portfolio/uninviteUser", {idPortfolio, idUser});
};

exports.sendPrivateMessage = function(idUserTo, message, title){
   return Ajax.post(baseURL + "/users/sendPrivateMessage", {idUserTo, message, title});
};

exports.initialDataFetch = function(filterObject){
   return Ajax.get(baseURL + '/initialDataFetch', {filterObject});
};

exports.getPublicHeadlines = function(){
   return Ajax.get('/getPublicHeadlines');
};

exports.getPublicAMACards = function(){
   return Ajax.get('/getPublicAMACards');
};

exports.addCardToEndOfPortfolio = function(idPortfolio, idCard, cardType, comment = null){
   return Ajax.post(baseURL + "/portfolio/addCardToEnd", {idPortfolio, idCard, cardType, comment});
};


exports.getSynthesisTemplates = function(){
   return Ajax.get(baseURL + '/portfolio/getSynthesisTemplates');
};

exports.getReviewQuestionTemplates = function(){
   return Ajax.get(baseURL + '/votes/getTemplates');
};

exports.getUserSocialNetwork = function(){
   return Ajax.get(baseURL + '/users/getSocialNetwork');
};

exports.sendCardInvites = function(card, userSelection){
   return Ajax.post(baseURL + "/card/sendInvites", {card, userSelection});
};

exports.getCardLeaderBoards = function(){
   return Ajax.get(baseURL + '/leaderBoard/cards');
};

exports.createPointBet = function(idCard, betAmount){
   return Ajax.post(baseURL + "/card/createPointBet", {idCard, betAmount});
};

exports.reportCard = function(cardType, idCard, message){
   return Ajax.post(baseURL + "/card/reportCard", {cardType, idCard, message});
};

exports.submitQuestionAnswer = function(idCard, answerText){
   return Ajax.post(baseURL + "/card/submitQuestionAnswer", {idCard, answerText});
};

exports.changePassword = function(oldPassword, password){
   return Ajax.post(baseURL + "/users/changeMyPassword", {oldPassword, password});
};
exports.resendVerificationEmail = function(email){
   return Ajax.post(baseURL + "/users/resendEmailAjax", { email });
};

exports.changeEmail = function(password, email){
   return Ajax.post(baseURL + "/users/changeEmail", {password, email});
};

exports.sendUserInvite = function(email){
   return Ajax.post(baseURL + "/users/inviteUser", {email});
};

exports.changeEmailOptOut = function(optedOut){
   return Ajax.post(baseURL + "/users/changeEmailOptOut", {optedOut});
};

exports.getLoginCountForUserByID = function(id){
   return Ajax.get(baseURL + "/users/getLoginCountForUserById?id=" + id);
};

exports.login = function(username, password){
   return Ajax.post(baseURL + "/loginAjax", {username, password});
};

exports.logClientError = function(errorMessage) {
   return Ajax.post(baseURL + "/logClientError", {errorMessage});
};

exports.getCardsToReview = function(){
   return Ajax.get(baseURL + '/cards/getCardsToReview');
};

exports.getLatestMPubs = function(limit, offset) {
   return Ajax.get(baseURL + `/mPubs/latest?limit=${limit}&offset=${offset}`);
};


exports.getLatestMPubsByDay = function(days, cardType) {
   return Ajax.get(baseURL + `/mPubs/latestByDay?days=${days}&cardType=${cardType}`);
};

exports.getLatestEvidence = function(limit, offset){
   return Ajax.get(baseURL + `/evidence/latest?limit=${limit}&offset=${offset}`);
};

exports.getLatestConjecture = function(limit, offset){
   return Ajax.get(baseURL + `/conjecture/latest?count=${limit}&offset=${offset}`);
};

exports.getMostUsefulConjecture = function(limit, offset, start, end){
   return Ajax.get(baseURL + `/conjecture/mostUseful?limit=${limit}&offset=${offset}&start=${start}&end=${end}`);
};

exports.deleteCardApproval = function(idCard, cardType){
   return Ajax.post(baseURL + "/votes/deleteCardApproval", {idCard, cardType});
};

exports.createUpvote = function(idCard, cardType){
   return Ajax.post(baseURL + "/card/upvote", {idCard, cardType});
};

exports.getUpvoteActivityForUserByID = function(id){
   return Ajax.get(baseURL + "/card/getUpvoteActivityForUserById?id=" + id);
};

exports.getSetting = function(setting){
   return Ajax.get(baseURL + "/getSetting?setting="+setting);
};

exports.getBracketByID = function(idPortfolio, idBracket){
   return Ajax.get(baseURL + `/incubator/getBracketByID?id=${idPortfolio}&idBracket=${idBracket}`);
};
exports.getBracketMatchesByID = function(idPortfolio, idBracket, fullData){
   return Ajax.get(baseURL + `/incubator/getBracketMatchesByID?idIncubator=${idPortfolio}&idBracket=${idBracket}&fullData=${fullData}`);
};

exports.getArpahSubmissionsForBracket = function(idBracket){
   return Ajax.get(baseURL + `/incubator/getArpahSubmissionsForBracket?idBracket=${idBracket}`);
};

exports.getArpahSubmissionsForCardInIncubator = function(idIncubator, idCard){
   return Ajax.get(baseURL + `/incubator/getArpahSubmissionsForCardInIncubator?idIncubator=${idIncubator}&idCard=${idCard}`);
};

exports.updateBracket = function(
   idBracket, idIncubator, title, subTitle, showScore,
   round1EndTime, round2EndTime, round3EndTime, round4EndTime, round5EndTime, round6EndTime,
   voteFudgeFactor, cardType,
   hideQuad0, hideQuad1, hideQuad2, hideQuad3,
   votingSuspended
){
   return Ajax.post(
      baseURL + "/incubator/updateBracket",
      {
         idBracket, idIncubator, title, subTitle, showScore,
         round1EndTime, round2EndTime, round3EndTime, round4EndTime, round5EndTime, round6EndTime,
         voteFudgeFactor, cardType,
         hideQuad0, hideQuad1, hideQuad2, hideQuad3,
         votingSuspended
      });
};

exports.createBracket = function(idIncubator, title, subTitle, showScore, round1EndTime, round2EndTime, round3EndTime, round4EndTime, round5EndTime, round6EndTime, voteFudgeFactor, cardType){
   return Ajax.post(baseURL + "/incubator/createBracket", {idIncubator, title, subTitle, showScore, round1EndTime, round2EndTime, round3EndTime, round4EndTime, round5EndTime, round6EndTime, voteFudgeFactor, cardType});
};

exports.deleteBracket = function(idIncubator, idBracket){
   return Ajax.post(baseURL + "/incubator/deleteBracket", {idIncubator, idBracket});
};
exports.updateBracketPositions = function(idIncubator, idBracket, positions, offset){
   return Ajax.post(baseURL + "/incubator/updateBracketPositions", {idIncubator, idBracket, positions, offset});
};
exports.advanceBracketVotingRound = function(idBracket, round, idIncubator){
   return Ajax.post(baseURL + "/incubator/advanceBracketVotingRound", {idBracket, round, idIncubator});
};

exports.addCardToBracket = function(idBracket, idIncubator, idCard, cardType, idCategory, selectedCardTitle, checkCanAdd = false){
   return Ajax.post(baseURL + "/incubator/addCardToBracket", {idBracket,idIncubator, idCard, cardType, idCategory, checkCanAdd, selectedCardTitle});
};
exports.addVoteToBracket = function(idBracketMatch, idIncubator, idBracket){
   return Ajax.post(baseURL + "/incubator/addVoteToBracket", {idBracketMatch, idIncubator, idBracket});
};
exports.deleteVoteFromBracket = function(idBracketMatch, idIncubator, idBracket){
   return Ajax.post(baseURL + "/incubator/deleteVoteFromBracket", {idBracketMatch, idIncubator, idBracket});
};
exports.getMissingBracketVotesForUser = function(idBracket, idIncubator){
   return Ajax.get(baseURL + `/incubator/getMissingBracketVotesForUser?idIncubator=${idIncubator}&idBracket=${idBracket}`);
}

exports.getUserBracketVotesWithMissing = function(idBracket, idIncubator){
   return Ajax.get(baseURL + `/incubator/getUserBracketVotesWithMissing?idIncubator=${idIncubator}&idBracket=${idBracket}`);
}

exports.getBracketVotesForUser = function(idBracket, idIncubator){
   return Ajax.get(baseURL + `/incubator/getBracketVotesForUser?idIncubator=${idIncubator}&idBracket=${idBracket}`);
}
exports.getWinningUserBracketVotes = function(idBracket, idIncubator, idRound = null){
   return Ajax.get(baseURL + `/incubator/getWinningUserBracketVotes?idIncubator=${idIncubator}&idBracket=${idBracket}${idRound?`&idRound=${idRound}`:''}`);
}
exports.getWinningBracketVotesForUser = function(idBracket, idIncubator, idUser, idRound = null){
   return Ajax.get(baseURL + `/incubator/getWinningBracketVotesForUser?idIncubator=${idIncubator}&idBracket=${idBracket}${idRound?`&idRound=${idRound}`:''}&idUser=${idUser}`);
}







exports.getManiaByID = function(idPortfolio, idMania){
   return Ajax.get(baseURL + `/incubator/getManiaByID?id=${idPortfolio}&idMania=${idMania}`);
};
exports.getManiaMatchesByID = function(idPortfolio, idMania){
   return Ajax.get(baseURL + `/incubator/getManiaMatchesByID?idIncubator=${idPortfolio}&idMania=${idMania}`);
};

exports.updateMania = function(idMania, idIncubator, title, round1EndTime, round2EndTime, round3EndTime, round4EndTime){
   return Ajax.post(baseURL + "/incubator/updateMania", {idMania, idIncubator, title, round1EndTime, round2EndTime, round3EndTime, round4EndTime});
};

exports.createMania = function(idIncubator, title, round1EndTime, round2EndTime, round3EndTime, round4EndTime){
   return Ajax.post(baseURL + "/incubator/createMania", {idIncubator, title, round1EndTime, round2EndTime, round3EndTime, round4EndTime});
};

exports.deleteMania = function(idIncubator, idMania){
   return Ajax.post(baseURL + "/incubator/deleteMania", {idIncubator, idMania});
};
exports.updateManiaPositions = function(idIncubator, idMania, positions, offset){
   return Ajax.post(baseURL + "/incubator/updateManiaPositions", {idIncubator, idMania, positions, offset});
};
exports.advanceManiaVotingRound = function(idMania, round, idIncubator){
   return Ajax.post(baseURL + "/incubator/advanceManiaVotingRound", {idMania, round, idIncubator});
};

exports.addCardToMania = function(idMania, idIncubator, idCard, cardType, idCategory, selectedCardTitle, checkCanAdd = false){
   return Ajax.post(baseURL + "/incubator/addCardToMania", {idMania,idIncubator, idCard, cardType, idCategory, checkCanAdd, selectedCardTitle});
};
exports.addVoteToMania = function(idManiaMatch, idIncubator, idMania){
   return Ajax.post(baseURL + "/incubator/addVoteToMania", {idManiaMatch, idIncubator, idMania});
};
exports.deleteVoteFromMania = function(idManiaMatch, idIncubator, idMania){
   return Ajax.post(baseURL + "/incubator/deleteVoteFromMania", {idManiaMatch, idIncubator, idMania});
};
exports.getMissingManiaVotesForUser = function(idMania, idIncubator){
   return Ajax.get(baseURL + `/incubator/getMissingManiaVotesForUser?idIncubator=${idIncubator}&idMania=${idMania}`);
}

exports.getManiaVotesForUser = function(idMania, idIncubator){
   return Ajax.get(baseURL + `/incubator/getManiaVotesForUser?idIncubator=${idIncubator}&idMania=${idMania}`);
}
exports.getWinningUserManiaVotes = function(idMania, idIncubator, idRound = null){
   return Ajax.get(baseURL + `/incubator/getWinningUserManiaVotes?idIncubator=${idIncubator}&idMania=${idMania}${idRound?`&idRound=${idRound}`:''}`);
}
exports.getWinningManiaVotesForUser = function(idMania, idIncubator, idUser, idRound = null){
   return Ajax.get(baseURL + `/incubator/getWinningManiaVotesForUser?idIncubator=${idIncubator}&idMania=${idMania}${idRound?`&idRound=${idRound}`:''}&idUser=${idUser}`);
}

exports.createArpahSubmission = function(hsfFocus, phFocus, ssFocus, rsFocus, shortTitle, explanation, currentImplementation, whatIsNew, idEvidence){
   return Ajax.post(
      baseURL + "/incubator/createArpahSubmission",
      {hsfFocus, phFocus, ssFocus, rsFocus, shortTitle, explanation, currentImplementation, whatIsNew, idEvidence}
   );
};

exports.getArpahSubmissions = function(){
   return Ajax.get(baseURL + `/incubator/getArpahSubmissions`);
}